var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconCmd(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "h5/sports-icon/black/icon-cmd") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "85.6578674%",
    y1: "77.6417024%",
    x2: "14.0511328%",
    y2: "5.64305065%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#001D44",
    offset: "9%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#002148",
    offset: "13%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F9ED6",
    offset: "83%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6E89A9",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "85.6578674%",
    y1: "77.6417024%",
    x2: "14.0511328%",
    y2: "5.64305065%",
    id: "linearGradient-2"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#079409",
    offset: "9%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#079409",
    offset: "13%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#079409",
    offset: "83%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#079409",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "85.6639839%",
    y1: "21.1648798%",
    x2: "14.0342052%",
    y2: "93.1663476%",
    id: "linearGradient-3"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#001D44",
    offset: "9%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#002148",
    offset: "13%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F9ED6",
    offset: "83%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6E89A9",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "85.6639839%",
    y1: "21.1648798%",
    x2: "14.0342052%",
    y2: "93.1663476%",
    id: "linearGradient-4"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#079409",
    offset: "9%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#079409",
    offset: "13%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#079409",
    offset: "83%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#079409",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    cx: "51.3635086%",
    cy: "89.3522743%",
    fx: "51.3635086%",
    fy: "89.3522743%",
    r: "64.9363178%",
    gradientTransform: "translate(0.5136, 0.8935), scale(0.6494, 1), translate(-0.5136, -0.8935)",
    id: "radialGradient-5"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F4C79",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#002853",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    cx: "51.3635086%",
    cy: "89.3522743%",
    fx: "51.3635086%",
    fy: "89.3522743%",
    r: "64.9363178%",
    gradientTransform: "translate(0.5136, 0.8935), scale(0.6494, 1), translate(-0.5136, -0.8935)",
    id: "radialGradient-6"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#079409",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#079409",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    cx: "31.0447761%",
    cy: "-33.5763547%",
    fx: "31.0447761%",
    fy: "-33.5763547%",
    r: "51.4286284%",
    gradientTransform: "translate(0.3104, -0.3358), scale(0.9468, 1), translate(-0.3104, 0.3358)",
    id: "radialGradient-7"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F4C79",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#002853",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    cx: "31.0447761%",
    cy: "-33.5763547%",
    fx: "31.0447761%",
    fy: "-33.5763547%",
    r: "51.4286284%",
    gradientTransform: "translate(0.3104, -0.3358), scale(0.9468, 1), translate(-0.3104, 0.3358)",
    id: "radialGradient-8"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#079409",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#079409",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    cx: "37.7454085%",
    cy: "-48.6424032%",
    fx: "37.7454085%",
    fy: "-48.6424032%",
    r: "55.6711574%",
    gradientTransform: "translate(0.3775, -0.4864), scale(0.8222, 1), translate(-0.3775, 0.4864)",
    id: "radialGradient-9"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F4C79",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#002853",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    cx: "37.7454085%",
    cy: "-48.6424032%",
    fx: "37.7454085%",
    fy: "-48.6424032%",
    r: "55.6711574%",
    gradientTransform: "translate(0.3775, -0.4864), scale(0.8222, 1), translate(-0.3775, 0.4864)",
    id: "radialGradient-10"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#079409",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#079409",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    cx: "61.0400218%",
    cy: "272.96215%",
    fx: "61.0400218%",
    fy: "272.96215%",
    r: "61.5425046%",
    gradientTransform: "translate(0.6104, 2.7296), scale(0.7025, 1), translate(-0.6104, -2.7296)",
    id: "radialGradient-11"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F4C79",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#002853",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    cx: "61.0400218%",
    cy: "272.96215%",
    fx: "61.0400218%",
    fy: "272.96215%",
    r: "61.5425046%",
    gradientTransform: "translate(0.6104, 2.7296), scale(0.7025, 1), translate(-0.6104, -2.7296)",
    id: "radialGradient-12"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#079409",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#079409",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50.0095672%",
    y1: "99.9829336%",
    x2: "50.0095672%",
    y2: "-0.0197516661%",
    id: "linearGradient-13"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#002853",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#174E7A",
    offset: "99%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50.0095672%",
    y1: "99.9829336%",
    x2: "50.0095672%",
    y2: "-0.0197516661%",
    id: "linearGradient-14"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#079409",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#079409",
    offset: "99%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50.0039361%",
    y1: "-556.89087%",
    x2: "50.0039361%",
    y2: "-457.89087%",
    id: "linearGradient-15"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#002853",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#174E7A",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50.0095672%",
    y1: "99.9829336%",
    x2: "50.0095672%",
    y2: "-0.0197516661%",
    id: "linearGradient-16"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#002853",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#174E7A",
    offset: "99%"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "path-17",
    points: "21.6178653 0 17.7699041 4.26395217 17.7699041 0 12.6566225 0 9.76198509 6.87858952 11.8672971 6.87858952 14.0699415 1.61598187 14.4486044 6.87858952 17.7365712 6.87858952 21.9631951 2.10930967 20.0552144 6.87858952 24.1018401 6.87858952 26.6991472 0"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50.0039361%",
    y1: "-556.89087%",
    x2: "50.0039361%",
    y2: "-457.89087%",
    id: "linearGradient-18"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#079409",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#079409",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50.0095672%",
    y1: "99.9829336%",
    x2: "50.0095672%",
    y2: "-0.0197516661%",
    id: "linearGradient-19"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#079409",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#079409",
    offset: "99%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "49.9987928%",
    y1: "-556.929638%",
    x2: "49.9987928%",
    y2: "-456.929638%",
    id: "linearGradient-20"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#002853",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#174E7A",
    offset: "99%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50.0095672%",
    y1: "99.9829336%",
    x2: "50.0095672%",
    y2: "-0.0197516661%",
    id: "linearGradient-21"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#002853",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#174E7A",
    offset: "99%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M35.793722,0.00133331838 L28.3431306,0.00133331838 L25.9084886,6.87992283 L33.2430811,6.87992283 C35.66039,6.87992283 36.5163813,5.91060037 36.7630455,5.33460683 C37.0097097,4.75861329 37.207041,4.34795123 37.832368,2.29330761 C38.457695,0.237330671 36.9763767,0.00399995514 35.793722,0.00399995514 L35.793722,0.00399995514 L35.793722,0.00133331838 Z M34.3297368,2.29064097 C34.0830726,2.98129989 33.9604072,3.43596146 33.3764131,4.67594755 C32.8577516,5.77326858 32.1270924,5.72793575 31.5350983,5.72793575 L29.5937846,5.72793575 L31.2391013,1.25465259 L33.7070764,1.25465259 C34.5790676,1.25465259 34.5790676,1.59998205 34.3324034,2.29064097 L34.3310701,2.29064097 L34.3297368,2.29064097 Z",
    id: "path-22"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "49.9987928%",
    y1: "-556.929638%",
    x2: "49.9987928%",
    y2: "-456.929638%",
    id: "linearGradient-23"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#079409",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#079409",
    offset: "99%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50.0095672%",
    y1: "99.9829336%",
    x2: "50.0095672%",
    y2: "-0.0197516661%",
    id: "linearGradient-24"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#079409",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#079409",
    offset: "99%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50.005782%",
    y1: "-824.944412%",
    x2: "50.005782%",
    y2: "-724.947656%",
    id: "linearGradient-25"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#002853",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#174E7A",
    offset: "99%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50.0095672%",
    y1: "99.9829336%",
    x2: "50.0095672%",
    y2: "-0.0197516661%",
    id: "linearGradient-26"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#002853",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#174E7A",
    offset: "99%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M12.5039864,1.41998407 C13.0959805,-0.0479994616 11.2213327,0.00266663676 10.2826756,0.00266663676 L4.57206662,0.00266663676 C1.74809516,0.00266663676 1.6494295,1.64264824 1.6494295,1.64264824 L4.67206561,1.64264824 C4.89473003,1.09998766 5.08006149,0.890656677 5.59738959,0.890656677 L8.73069125,0.890656677 C9.42135094,0.890656677 9.48268365,1.03865502 9.34668503,1.2986521 C9.21201972,1.55731587 9.0626879,1.91464519 8.8413568,2.23597492 C8.61869239,2.55597133 8.39736129,2.69330312 7.96669898,2.69330312 L5.31472578,2.69330312 L4.94539618,3.77862429 L7.54803654,3.77862429 C8.04136489,3.77862429 8.15203044,3.91328944 8.07869784,4.12395375 C8.00536525,4.33328473 7.83203367,4.67861419 7.65870209,5.06127657 C7.48537051,5.44393894 7.21470658,5.51860477 6.85737686,5.51860477 L3.18141401,5.51860477 C2.83608417,5.51860477 3.18141401,4.87594531 3.18141401,4.87594531 L0.232110488,4.87594531 C-0.519881911,6.45459427 0.701439078,6.51592692 1.8107612,6.51592692 L8.37202821,6.51592692 C10.3453416,6.51592692 10.6786716,5.77593522 11.2333326,4.56794877 C11.7879937,3.358629 10.8520031,3.28529648 10.8520031,3.28529648 C11.7026612,3.17463106 11.9119924,2.89196756 12.5039864,1.42265071 L12.5039864,1.42265071 L12.5039864,1.41998407 Z",
    id: "path-27"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50.005782%",
    y1: "-824.944412%",
    x2: "50.005782%",
    y2: "-724.947656%",
    id: "linearGradient-28"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#079409",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#079409",
    offset: "99%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50.0095672%",
    y1: "99.9829336%",
    x2: "50.0095672%",
    y2: "-0.0197516661%",
    id: "linearGradient-29"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#079409",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#079409",
    offset: "99%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50.0153072%",
    y1: "-825.061425%",
    x2: "50.0153072%",
    y2: "-725.061425%",
    id: "linearGradient-30"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#002853",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#174E7A",
    offset: "99%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50.0095672%",
    y1: "99.9829336%",
    x2: "50.0095672%",
    y2: "-0.0197516661%",
    id: "linearGradient-31"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#002853",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#174E7A",
    offset: "99%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M22.0132237,2.62797052 L16.833276,2.62797052 C16.833276,2.62797052 17.2026056,1.59198214 17.3266044,1.31998519 C17.4492698,1.04932156 17.6106015,0.765324749 18.1772624,0.765324749 L21.3838967,0.765324749 C22.0118903,0.765324749 21.9638908,1.21331972 21.9638908,1.21331972 L25.1585252,1.21331972 C25.3718564,0.177331344 23.6625403,0 22.7905491,0 L17.3546041,0 C15.1186267,0 14.2959683,0.431995155 13.9266387,1.29465215 C13.6293084,1.98931102 12.714651,4.05062123 12.3626545,4.94527787 C11.7826604,6.41726136 12.9493153,6.51192696 14.0213044,6.51192696 L20.9652343,6.51192696 C22.8278821,6.51192696 23.3332103,5.7599354 23.961204,4.16795325 C24.5891976,2.57730443 22.739883,2.62663721 22.0132237,2.62663721 L22.0118903,2.62663721 L22.0132237,2.62797052 Z M19.509249,5.55593768 L16.2946148,5.55593768 C15.5546223,5.55593768 16.0386174,4.59328181 16.3679474,3.93595585 L20.7919027,3.93595585 C20.7919027,3.93595585 20.4959057,5.55593768 19.509249,5.55593768 Z",
    id: "path-32"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50.0153072%",
    y1: "-825.061425%",
    x2: "50.0153072%",
    y2: "-725.061425%",
    id: "linearGradient-33"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#079409",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#079409",
    offset: "99%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50.0095672%",
    y1: "99.9829336%",
    x2: "50.0095672%",
    y2: "-0.0197516661%",
    id: "linearGradient-34"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#079409",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#079409",
    offset: "99%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50.0017466%",
    y1: "-824.912999%",
    x2: "50.0017466%",
    y2: "-724.912999%",
    id: "linearGradient-35"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#002853",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#174E7A",
    offset: "99%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50.0095672%",
    y1: "99.9829336%",
    x2: "50.0095672%",
    y2: "-0.0197516661%",
    id: "linearGradient-36"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#002853",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#174E7A",
    offset: "99%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M36.0744149,0 L29.6238134,0 C26.9718402,0 26.6518434,1.33198506 26.4171792,2.24530815 C26.1825149,3.15863124 27.0091732,3.2572968 27.0091732,3.2572968 C25.4918552,3.65062572 25.3571899,4.42128374 25.1225256,5.42793912 C24.9318608,6.25059656 25.6278538,6.51326028 26.9358406,6.51326028 L33.5211073,6.51326028 C35.199757,6.51326028 35.5690866,5.59993719 36.062415,4.4906163 C36.5557433,3.38129541 35.5810865,3.2572968 35.5810865,3.2572968 C36.4810774,3.14663137 36.9250729,2.64130371 37.3450687,1.62931506 C37.7650644,0.617326409 37.3450687,0.00133331838 36.0744149,0.00133331838 L36.0744149,0.00133331838 L36.0744149,0 Z M32.7557817,4.74928006 C32.6491162,5.11860926 32.5931167,5.61193706 31.910457,5.61193706 L28.8824876,5.61193706 C28.4624918,5.61193706 28.4064924,5.49727168 28.5038247,5.12660917 C28.6331568,4.63328137 28.7264891,3.96795549 29.5398143,3.96795549 L32.5744502,3.96795549 C33.0011126,3.96795549 32.8637807,4.37861756 32.7544484,4.74928006 L32.7557817,4.74928006 L32.7557817,4.74928006 Z M33.9651029,1.70664752 C33.8584373,2.07597672 33.8024378,2.56930452 33.1197781,2.56930452 L30.0918087,2.56930452 C29.6718129,2.56930452 29.6158135,2.45463914 29.7131458,2.08397663 C29.8424779,1.59064883 29.9358103,0.925322955 30.7491354,0.925322955 L33.7837714,0.925322955 C34.2104337,0.925322955 34.0731018,1.33598502 33.9637695,1.70664752 L33.9651029,1.70664752 L33.9651029,1.70664752 Z",
    id: "path-37"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50.0017466%",
    y1: "-824.912999%",
    x2: "50.0017466%",
    y2: "-724.912999%",
    id: "linearGradient-38"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#079409",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#079409",
    offset: "99%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50.0095672%",
    y1: "99.9829336%",
    x2: "50.0095672%",
    y2: "-0.0197516661%",
    id: "linearGradient-39"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#079409",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#079409",
    offset: "99%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "84.6558906%",
    y1: "84.6945472%",
    x2: "20.0611375%",
    y2: "-0.727954696%",
    id: "linearGradient-40"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#001D44",
    offset: "9%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#002148",
    offset: "13%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F9ED6",
    offset: "83%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6E89A9",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "84.6558906%",
    y1: "84.6945472%",
    x2: "20.0611375%",
    y2: "-0.727954696%",
    id: "linearGradient-41"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#079409",
    offset: "9%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#079409",
    offset: "13%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#079409",
    offset: "83%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#079409",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "h5/sports-icon/black/icon-cmd",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u8CC7\\u7522-4",
    transform: "translate(0, 2.1633)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "url(#linearGradient-2)",
    points: "36.1170811 5.06767844 38.4837239 5.80633682 36.854407 4.03302338 37.9890622 2.43704128 35.8437505 2.9317024 34.3197659 1.27172102 34.5264305 3.23703231 32.069122 3.80502594 34.6730957 4.61701683 34.9010934 6.7769926"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "url(#linearGradient-4)",
    points: "32.7011156 6.16366615 33.6797724 6.46899606 33.0064459 5.73567095 33.4757745 5.07567835 32.5891168 5.28100938 31.9584565 4.59435042 32.0451223 5.40634131 31.0291325 5.64100535 32.1051217 5.97700158 32.1997874 6.86899157"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0692635,17.0302109 L18.6572576,15.7862249 L17.9865977,14.764903 L18.8705888,15.6582263 L21.6612272,15.6582263 L22.7292164,14.4342401 L21.8625585,15.7315588 L22.7292164,17.2875414 C22.7292164,17.2875414 20.1225761,17.9408674 18.0705968,17.0288776 L18.0679302,17.0288776 L18.0692635,17.0302109 Z",
    id: "Path",
    fill: "url(#radialGradient-6)"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "url(#radialGradient-8)",
    points: "12.8066501 9.58629443 15.4719564 10.4329516 16.5266125 12.4609289 15.7052874 10.2982864 17.4359366 8.3729747 19.9532445 8.43297403 17.5999349 8.05964488 15.9386184 5.69433808 12.9666484 6.75165956"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "url(#radialGradient-10)",
    points: "21.0718998 13.0222559 22.473219 10.9369459 21.685227 8.13697735 24.6318639 6.09833355 27.0998389 8.07431139 29.4931481 7.22765422 27.2838371 8.41964085 25.737186 11.1316104 26.3118469 12.0316003 25.5278548 11.284942 22.5798846 11.1929431"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8305892,0.895725236 L19.4185832,2.35704218 L18.2999279,3.54636217 L19.6172479,2.5543733 L22.0932229,2.78503738 L23.098546,4.02369015 L22.4118863,2.71037155 L23.1972117,0.894391918 C23.1972117,0.894391918 21.0985662,0.194399769 18.8265892,0.894391918 L18.8292558,0.894391918 L18.8305892,0.895725236 Z",
    id: "Path",
    fill: "url(#radialGradient-12)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(0, 21.4275)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.0193, 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.15805184,4.59994841 C3.1820516,4.1426202 3.56604772,3.31729613 4.15670841,2.19464205 C4.74870243,1.07332129 5.31536337,1.07332129 6.09268885,1.07332129 L10.3593124,1.07332129 L10.8899737,0 L3.95804376,0 C1.47806882,0 0.48074557,2.56530456 0.0607498151,4.66261437 C-0.376579098,6.85325647 1.6647336,6.75859086 2.42872588,6.746591 C3.36604974,6.73192449 7.67000624,6.746591 7.67000624,6.746591 L8.20066754,5.58793732 L4.6727032,5.58793732 C3.11805225,5.58793732 3.13138544,5.05727661 3.1553852,4.60128172 L3.1553852,4.60128172 L3.15805184,4.59994841 Z",
    id: "Path",
    fill: "url(#linearGradient-14)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Path"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-18)",
    xlinkHref: "#path-17"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-19)",
    xlinkHref: "#path-17"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Shape"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-23)",
    xlinkHref: "#path-22"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-24)",
    xlinkHref: "#path-22"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0, 7.8932)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-28)",
    xlinkHref: "#path-27"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-29)",
    xlinkHref: "#path-27"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Shape"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-33)",
    xlinkHref: "#path-32"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-34)",
    xlinkHref: "#path-32"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Shape"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-38)",
    xlinkHref: "#path-37"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-39)",
    xlinkHref: "#path-37"
  })))), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "url(#linearGradient-41)",
    points: "4.13073775 19.9101786 6.16671717 20.799502 4.88939675 19.0595215 6.05605162 17.7488695 4.09740475 17.9808669 2.90275016 16.3528852 2.89475024 18.1221987 0.649439603 18.387529 2.88941696 19.3661847 2.88141704 21.3128296"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.91070965,16.5675495 C6.91870957,17.5275387 7.42403779,18.2048644 8.23336295,18.4901946 C9.40935106,18.9061899 10.6333387,19.3115187 11.8639929,19.4221841 C14.8826291,19.6955144 17.8025996,19.048855 20.663904,18.123532 C20.7465698,18.0968656 20.8252357,18.0528661 20.8985683,18.0048667 C20.9279013,17.9862002 20.9385679,17.9355341 20.9785675,17.8582016 C16.2799483,17.6128711 13.6639747,14.9809006 12.6013188,10.4196184 C10.2226762,12.268931 8.96668887,14.5422388 9.09468757,17.5208721 C9.0360215,17.5315386 8.97735543,17.5408719 8.91868935,17.5515384 C8.73335789,16.7795471 8.45602736,16.016889 8.37602817,15.2342311 C7.83070035,9.8529581 10.1040107,4.39835262 15.1466264,1.59171743 C18.7265902,-0.401593546 22.4678857,-0.704256818 26.0025167,1.73038254 C29.0238195,3.81035921 30.2784735,6.84365852 29.7744785,10.4476181 C29.2891501,13.9249124 27.2758371,16.3622184 23.9918703,17.6222043 C21.914558,18.4195287 19.8039127,19.1715203 17.6492678,19.7101809 C14.9252953,20.3915066 12.1359902,20.5155052 9.36935146,19.8101798 C8.45069408,19.5755157 7.62403577,19.166187 7.06670807,18.3488628 C6.68271195,17.7848691 6.5853796,17.1902091 6.90804301,16.5662161 L6.91070965,16.5675495 Z M29.5091479,8.99030111 C29.6531464,5.10501136 26.137182,0.79439304 20.9385679,0.929058196 C17.0972734,1.02905707 12.8746494,4.28768719 13.1973128,9.68229335 C13.4493102,13.902246 17.0279407,17.3275409 21.4172297,17.2248754 C26.0211832,17.1182099 29.5731473,13.5475833 29.5091479,8.98896779 L29.5091479,8.99030111 Z M16.1946158,2.17304424 C11.8253266,2.88636958 7.68003521,10.7702811 8.81202376,16.1395543 C8.89735624,15.8808905 8.96402223,15.7302255 8.99602191,15.5715606 C9.42801754,13.4382512 10.4413406,11.6569379 12.1279902,10.2556203 C12.3413214,10.0782889 12.5079864,9.71562631 12.5133197,9.43562945 C12.5746524,6.54899516 13.631975,4.15168872 15.9106187,2.33437577 C15.9946178,2.26770985 16.0999501,2.22637698 16.1946158,2.17437756 L16.1946158,2.17304424 Z",
    id: "Shape",
    fill: "#079409"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCmd);
export default __webpack_public_path__ + "static/media/icon-cmd.39f88f4f64329dbc4c9d1d775cc9449e.svg";
export { ForwardRef as ReactComponent };